import { storyblokEditable } from "@storyblok/react";
import BrandLink from "./BrandLink";

function BrandList3({ blok }) {
  if (!blok) return null;

  return (
    <section
      key={blok._uid}
      {...storyblokEditable(blok)}
      className="storyblok-brands-list-3"
    >
      <div className="d-block d-lg-none">
        <BrandLink
          className="brand-hero"
          title={blok.brand_hero_title}
          brandLink={blok.brand_hero_link?.url}
          src={blok.brand_hero_image?.filename}
          alt={`${blok.brand_hero_title} image`}
          trackingName="brandList3"
        />
        <div className="d-flex gap-3 justify-content-between w-100">
          <BrandLink
            className="brand-left"
            title={blok.brand_left_title}
            brandLink={blok.brand_left_link?.url}
            src={blok.brand_left_image?.filename}
            alt={`${blok.brand_left_title} image`}
            trackingName="brandList3"
          />
          <BrandLink
            className="brand-right"
            title={blok.brand_right_title}
            brandLink={blok.brand_right_link?.url}
            src={blok.brand_right_image?.filename}
            alt={`${blok.brand_right_title} image`}
            trackingName="brandList3"
          />
        </div>
      </div>

      <div className="d-none d-lg-flex">
        <div className="d-flex w-100 gap-3">
          <BrandLink
            className="brand-left"
            title={blok.brand_left_title}
            brandLink={blok.brand_left_link?.url}
            src={blok.brand_left_image?.filename}
            alt={`${blok.brand_left_title} image`}
            trackingName="brandList3"
          />
          <BrandLink
            className="brand-hero"
            title={blok.brand_hero_title}
            brandLink={blok.brand_hero_link?.url}
            src={blok.brand_hero_image?.filename}
            alt={`${blok.brand_hero_title} image`}
            trackingName="brandList3"
          />
          <BrandLink
            className="brand-right"
            title={blok.brand_right_title}
            brandLink={blok.brand_right_link?.url}
            src={blok.brand_right_image?.filename}
            alt={`${blok.brand_right_title} image`}
            trackingName="brandList3"
          />
        </div>
      </div>
    </section>
  );
}

export default BrandList3;
